import { useState } from 'react'
import { format } from 'date-fns'
import { DashboardFiltersBar } from '@/components/dashboard/DashboardFilters'
import { SummaryCards } from '@/components/dashboard/SummaryCards'
import { TopClientsChart } from '@/components/dashboard/TopClientsChart'
import { SubcategoryChart } from '@/components/dashboard/SubcategoryChart'
import { DestinationChart } from '@/components/dashboard/DestinationChart'
import { MonthlyTrendChart } from '@/components/dashboard/MonthlyTrendChart'
import { OperationalAlertsPanel } from '@/components/dashboard/OperationalAlertsPanel'
import {
  useDashboardSummary,
  useDashboardByClient,
  useDashboardBySubcategory,
  useDashboardByDestination,
  useDashboardMonthlyTrend,
  useDashboardOperationalAlerts,
} from '@/hooks/queries/useDashboard'
import type { DashboardFilters } from '@/types'

export function DashboardPage() {
  const [filters, setFilters] = useState<DashboardFilters>({
    period: format(new Date(), 'yyyy-MM'),
  })

  const summary = useDashboardSummary(filters)
  const byClient = useDashboardByClient(filters)
  const bySubcategory = useDashboardBySubcategory(filters)
  const byDestination = useDashboardByDestination(filters)
  const monthlyTrend = useDashboardMonthlyTrend(filters)
  const operationalAlerts = useDashboardOperationalAlerts(filters)

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Panel de indicadores</h1>
        <p className="text-sm text-muted-foreground">Métricas y KPIs operacionales</p>
      </div>

      <DashboardFiltersBar value={filters} onChange={setFilters} />

      <SummaryCards data={summary.data} isLoading={summary.isLoading} />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <TopClientsChart data={byClient.data} isLoading={byClient.isLoading} />
        <SubcategoryChart data={bySubcategory.data} isLoading={bySubcategory.isLoading} />
      </div>

      <DestinationChart data={byDestination.data} isLoading={byDestination.isLoading} />

      <MonthlyTrendChart data={monthlyTrend.data} isLoading={monthlyTrend.isLoading} />

      <OperationalAlertsPanel
        data={operationalAlerts.data}
        isLoading={operationalAlerts.isLoading}
      />
    </div>
  )
}
